import { WebApiRequest, HTTP_GET, HTTP_POST, HTTP_DELETE } from "tools/webservice";
import { CaseConfigurationsProperties, CaseConfigurationsMetadata } from "interfaces/Mueller.Business.Models";

const getUri = (surveyTypeCode: string | null, customerNumber: string | null) => {
  let params = "";
  const addParam = (name: string, value: string) => {
    if (params.length == 0)
      params += "?";
    else
      params += "&";

    params += `${name}=${value}`;
  }

  if(surveyTypeCode) addParam("surveyType", surveyTypeCode);
  if(customerNumber) addParam("customer", customerNumber);

  return `/case-configurations${params}`;
};

export const getCaseConfigurations = (surveyTypeCode: string | null, customerNumber: string | null, successCallback: (config: CaseConfigurationsProperties) => void, mountedRef) => {
  WebApiRequest({
    method: HTTP_GET,
    endpoint: getUri(surveyTypeCode, customerNumber),
    mountedRef: mountedRef,
    successCallback: successCallback,
  });    
};

export const createUpdateCaseConfigurations = (surveyTypeCode: string | null, customerNumber: string | null, payload: CaseConfigurationsProperties, successCallback: () => void, mountedRef) => {
  WebApiRequest({
    method: HTTP_POST,
    endpoint: getUri(surveyTypeCode, customerNumber),
    payload,
    mountedRef: mountedRef,
    successCallback: successCallback,
  });    
};

export const deleteCaseConfigurations = (surveyTypeCode: string | null, customerNumber: string | null, successCallback: () => void, mountedRef) => {
  WebApiRequest({
    method: HTTP_DELETE,
    endpoint: getUri(surveyTypeCode, customerNumber),
    mountedRef: mountedRef,
    successCallback: successCallback,
  });    
};

export const getCaseConfigurationsMetadata = (successCallback: (metadata: CaseConfigurationsMetadata[]) => void, mountedRef) => {
  WebApiRequest({
    method: HTTP_GET,
    endpoint: "/case-configurations/metadata",
    mountedRef: mountedRef,
    successCallback: successCallback,
  });    
};